import { SUBCATEGORIES_API, SUBCATEGORY_NDI_API } from '../../../../Utilities/APIs'
import PcDILtNST from '../../../Partials/Layouts/CRUDs/CRUDLayouts/DILtNST/PcDILtNST'
// import PcDINSCRUD from '../../../Partials/Layouts/CRUDs/CRUDLayouts/DINSCRUD/PcDINSCRUD'

function SubcategoryNDICards() {
  return (
    <PcDILtNST
        // parentChild props
        parentDBField={'subcategory'}

        // common props
        api={SUBCATEGORY_NDI_API}
        screenTopicSingular={'Subcategory NDI'}
        screenTopicPlural={'Subcategory NDIs'}
        
        // crud header props
        showTotalInHeading
        
        // crud props
        allowCreate
        allowUpdate
        allowDelete
        
        // select props
        selectApi={SUBCATEGORIES_API}
        selectType={'parent-child'}
        selectDBField={'subcategory'}
        selectName={'Subcategory'}

        // long text props
        longTextDBField={'engDescription'}
        longTextName={'English Description'}

        //text props
        textDBField={'engName'}
        textName={'English Name'}
    />
  )
}

export default SubcategoryNDICards